<div class="search-container" id="search_inner">

  <div class="search_inner">
    <input class="form-control" type="text" name="search" placeholder="Search" tabindex="1" (keyup.enter)="onEnter()"
      [(ngModel)]="searchString" (ngModelChange)="queryChanged($event)">
    <button class="head_search_ico" type="submit" *ngIf="!isESignature" (click)="addClass('expand_search')"><i
        class="header_search"></i></button>
    <div class="search-suggestion">
      <ul *ngFor="let data of searchResultsFacWise">
        <li>
          <h4><i class="fas fa-lock"></i> Customers</h4>
          <div>
            <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
            <span *ngIf="data.resultSetRented.length" style="color: green;padding-left: 10px;"> Rented</span>
            <ul *ngFor="let item of data.resultSetRented">
              <li>
                <ul>
                  <li (click)="routeToCustomer(item, 1)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              </li>
            </ul>
            <span *ngIf="data.resultSetMovedOut.length" style="color: red;padding-left: 10px;"> Moved Out</span>
            <ul *ngFor="let item of data.resultSetMovedOut">
              <li>
                <ul>
                  <li (click)="routeToCustomer(item, 1)">
                    <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
                  </li>
                </ul>
              </li>
            </ul>
            <ul *ngIf="searchComplete | async">
              <div class="searchContainer">
                <div id="Searchloader"></div>
              </div>
            </ul>
            <ul *ngIf="!searchResults.RentalModel.length && isRecordsEmpty">
              <li>No records found</li>
            </ul>
          </div>

        </li>
        <li>
          <h4><i class="far fa-hourglass"></i> Reservation</h4>
          <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
          <span *ngIf="data.resultSetResNew.length" style="color: green;padding-left: 10px;"> New Reservation</span>
          <ul *ngFor="let item of data.resultSetResNew">
            <li (click)="routeToCustomer(item, 2)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetResConfirmed.length" style="color: green;padding-left: 10px;"> Confirmed</span>
          <ul *ngFor="let item of data.resultSetResConfirmed">
            <li (click)="routeToCustomer(item, 2)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetResPending.length" style="color: green;padding-left: 10px;"> Pending</span>
          <ul *ngFor="let item of data.resultSetResPending">
            <li (click)="routeToCustomer(item, 2)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetResCancelled.length" style="color: red;padding-left: 10px;"> Cancelled</span>
          <ul *ngFor="let item of data.resultSetResCancelled">
            <li (click)="routeToCustomer(item, 2)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetResExpired.length" style="color: red;padding-left: 10px;"> Expired</span>
          <ul *ngFor="let item of data.resultSetResExpired">
            <li (click)="routeToCustomer(item, 2)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <ul *ngIf="searchComplete | async">
            <div class="searchContainer">
              <div id="Searchloader"></div>
            </div>
          </ul>
          <ul *ngIf="!searchResults.ReservationModel.length && isRecordsEmpty">
            <li>No records found</li>
          </ul>
        </li>
        <li>
          <h4><i class="far fa-user"></i> Prospects</h4>
          <h6 style="background-color: #3757C5; color: #fff;">{{data.facName}}</h6>
          <span *ngIf="data.resultSetInqOpen.length" style="color: green;padding-left: 10px;"> Open</span>
          <ul *ngFor="let item of data.resultSetInqOpen">
            <li (click)="routeToCustomer(item, 3)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetInqConfirmed.length" style="color: green;padding-left: 10px;"> Confirmed</span>
          <ul *ngFor="let item of data.resultSetInqConfirmed">
            <li (click)="routeToCustomer(item, 3)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetInqPending.length" style="color: green;padding-left: 10px;"> Pending</span>
          <ul *ngFor="let item of data.resultSetInqPending">
            <li (click)="routeToCustomer(item, 3)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetInqClosed.length" style="color:red;padding-left: 10px;"> Closed</span>
          <ul *ngFor="let item of data.resultSetInqClosed">
            <li (click)="routeToCustomer(item, 3)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>
          <span *ngIf="data.resultSetInqCancelled.length" style="color:red;padding-left: 10px;"> Cancelled</span>
          <ul *ngFor="let item of data.resultSetInqCancelled">
            <li (click)="routeToCustomer(item, 3)">
              <span highlighter [target]="item.searchResult" [searchText]="searchString"></span>
            </li>
          </ul>

          <ul *ngIf="searchComplete | async">
            <div class="searchContainer">
              <div id="Searchloader"></div>
            </div>
          </ul>
          <ul *ngIf="!searchResults.ProspectModel.length && isRecordsEmpty">
            <li>No records found</li>
          </ul>

        </li>
      </ul>
      <ul *ngIf="searchComplete | async">
        <div class="searchContainer">
          <div id="Searchloader"></div>
        </div>
      </ul>
      <ul *ngIf="searchResultsFacWise.length == 0  && isRecordsEmpty">
        <li style="text-align: center;">No records to display</li>
      </ul>
    </div>
  </div>
  <div class="close_search" (click)="removeClass('expand_search')"></div>


</div>

<ng-template #templateConfirm>

  <div class="modal-header">
    <h5 class="modal-title">Confirm</h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef1.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ptb24">
    <div class="row mx-0">
      The record you are trying to access is from a different location. Do you wish to proceed?
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef1.hide()">No</button>
    <button class="btn btn-primary" type="button" (click)="proceedRouteDifferentStore()">Yes</button>

  </div>
</ng-template>